import { CreditDocument } from '_gql'

export const getDocumentTypeForTracking = (documentType: CreditDocument) => {
  switch (documentType) {
    case CreditDocument.BANK_STATEMENT:
      return 'bankStatement'
    case CreditDocument.BANK_VERIFICATION:
      return 'bankVerification'
    case CreditDocument.BPAV:
      return 'bpav'
    case CreditDocument.BUSINESS_REGISTRATION:
      return 'businessRegistration'
    case CreditDocument.BO1_DRIVERS_LICENSE:
    case CreditDocument.BO1_DRIVERS_LICENSE_BACK:
    case CreditDocument.BO2_DRIVERS_LICENSE:
    case CreditDocument.BO2_DRIVERS_LICENSE_BACK:
    case CreditDocument.BO3_DRIVERS_LICENSE:
    case CreditDocument.BO3_DRIVERS_LICENSE_BACK:
    case CreditDocument.BO4_DRIVERS_LICENSE:
    case CreditDocument.BO4_DRIVERS_LICENSE_BACK:
    case CreditDocument.CP_DRIVERS_LICENSE:
    case CreditDocument.CP_DRIVERS_LICENSE_BACK:
      return 'driversLicense'
    case CreditDocument.FINANCIAL_DOCUMENTS:
      return 'financialDocuments'
    case CreditDocument.BO1_GREEN_CARD:
    case CreditDocument.BO2_GREEN_CARD:
    case CreditDocument.BO3_GREEN_CARD:
    case CreditDocument.BO4_GREEN_CARD:
    case CreditDocument.CP_GREEN_CARD:
      return 'greencard'
    case CreditDocument.INTERIM_FINANCIALS:
      return 'interimFinancials'
    case CreditDocument.BO1_PASSPORT:
    case CreditDocument.BO2_PASSPORT:
    case CreditDocument.BO3_PASSPORT:
    case CreditDocument.BO4_PASSPORT:
    case CreditDocument.CP_PASSPORT:
      return 'passport'
    case CreditDocument.BO1_SSN_CARD:
    case CreditDocument.BO2_SSN_CARD:
    case CreditDocument.BO3_SSN_CARD:
    case CreditDocument.BO4_SSN_CARD:
    case CreditDocument.CP_SSN_CARD:
      return 'ssnCard'
    case CreditDocument.BO1_PHYSICAL_ADDRESS_VERIFICATION:
    case CreditDocument.BO2_PHYSICAL_ADDRESS_VERIFICATION:
    case CreditDocument.BO3_PHYSICAL_ADDRESS_VERIFICATION:
    case CreditDocument.BO4_PHYSICAL_ADDRESS_VERIFICATION:
    case CreditDocument.CP_PHYSICAL_ADDRESS_VERIFICATION:
      return 'physicalAddressVerification'
    case CreditDocument.TAX_ID:
      return 'taxId'
    case CreditDocument.BO1_US_VISA:
    case CreditDocument.BO2_US_VISA:
    case CreditDocument.BO3_US_VISA:
    case CreditDocument.BO4_US_VISA:
    case CreditDocument.CP_US_VISA:
      return 'usVisa'
    default:
      return 'other'
  }
}
